// /directory — «Справочник» (005, сценарии 2–5): люди и организации из протоколов. Право —
// directory.read; какие записи видны, решает сервер по областям. Условия — в адресе под именами
// запроса directory.records.list, плюс record (карточка справа) и pair (окно сравнения):
// /directory?kind=person&record=<id>, /directory?addressee=missing, /directory?pair=<id>.
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { DirectoryPage } from '../../features/directory/DirectoryPage.tsx';
import { normalizeDirectorySearch, parseDirectorySearch } from '../../features/directory/search.ts';
import type { DirectorySearch } from '../../features/directory/search.ts';
import { requireSection } from '../../shell/permissions.ts';

export const Route = createFileRoute('/_app/directory')({
  validateSearch: parseDirectorySearch,
  beforeLoad: requireSection('directory'),
  staticData: { crumb: 'Справочник' },
  component: DirectoryRoute,
});

function DirectoryRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  // Условия списка меняют адрес на месте; открытие карточки и окна сравнения — новый шаг истории:
  // «Назад» закрывает их.
  const onSearchChange = useCallback(
    (next: DirectorySearch, options: { push?: boolean } = {}) =>
      void navigate({
        to: '/directory',
        search: normalizeDirectorySearch(next),
        replace: !options.push,
      }),
    [navigate],
  );
  return <DirectoryPage search={search} onSearchChange={onSearchChange} />;
}
